// extracted by mini-css-extract-plugin
export default {"imgCss":"ImagePicker_imgCss__PX7R8"};